import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model'

export class FuseNavigationModel implements FuseNavigationModelInterface {
  public model: any[]

  constructor() {
    this.model = [
      // {
      //   'id': 'dashboard',
      //   'title': 'Dashboard',
      //   'translate': 'NAV.DASHBOARD',
      //   'type': 'item',
      //   'icon': 'dashboard',
      //   'url': '/dashboard'
      // },
      {
        id: 'administrations',
        title: 'Administraties',
        translate: 'NAV.ADMINISTRATIONS',
        type: 'item',
        icon: 'business',
        url: '/administrations',
      },
      {
        id: 'users',
        title: 'Users',
        translate: 'NAV.USERS',
        type: 'item',
        icon: 'supervisor_account',
        url: '/users',
      },
      {
        id: 'documents',
        title: 'Document',
        translate: 'NAV.DOCUMENTS',
        type: 'item',
        icon: 'folder',
        url: '/documents',
      },
      {
        id: 'prospects',
        title: 'Prospects',
        translate: 'NAV.PROSPECTS',
        type: 'collapse',
        icon: 'group_add',
        children: [
          {
            id: 'addProspect',
            title: 'Add Prospect',
            translate: 'NAV.ADD_PROSPECT',
            type: 'item',
            url: '/prospect',
          },
          // {
          //   id: 'prospects',
          //   title: 'All Prospect',
          //   translate: 'NAV.PROSPECTS',
          //   type: 'item',
          //   url: '/prospects/all'
          // },
          // {
          //   id: 'pendingProspects',
          //   title: 'Pending Prospect',
          //   translate: 'NAV.PROSPECT_PENDING',
          //   type: 'item',
          //   url: '/prospects/new'
          // },
          // {
          //   id: 'acceptedProspects',
          //   title: 'Accepted Prospect',
          //   translate: 'NAV.PROSPECT_ACCEPTED',
          //   type: 'item',
          //   url: '/prospects/accepted'
          // },
          // {
          //   id: 'rejectedProspects',
          //   title: 'Rejected Prospect',
          //   translate: 'NAV.PROSPECT_REJECTED',
          //   type: 'item',
          //   url: '/prospects/rejected'
          // },
          // {
          //   id: 'processedProspects',
          //   title: 'Processed Prospect',
          //   translate: 'NAV.PROSPECT_PROCESSED',
          //   type: 'item',
          //   url: '/prospects/processed'
          // }
        ],
      },
      // {
      //   'id': 'ledger',
      //   'title': 'Boekhouding',
      //   'type': 'item',
      //   'icon': 'apps',
      // },
      // {
      //   'id': 'system',
      //   'title': 'System',
      //   'translate': 'NAV.SYSTEM',
      //   'type': 'group',
      //   'icon': 'apps',
      //   'children': [
      //     {
      //       'id': 'origin',
      //       'title': 'Origin',
      //       'translate': 'NAV.ORIGIN',
      //       'type': 'item',
      //       'icon': 'today',
      //       'url': '/system/origins'
      //     },
      //   ]
      // }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.model.ts